import "./sitemap.css";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import infoIcon from "../../assets/info.svg";

export const Sitemap = () => {
    const cv_file = useIntl().messages.cv_file;
    useEffect(() => {
        document.querySelector(".sitemapLink").style.display="none";
        return () => {
            document.querySelector(".sitemapLink").style.display="block";
        }
    });
    return (
        <div className="view sitemap">
            <Link to={"../home"}><button className="reveal reveal-area action top left round align-center"><img draggable="false" alt="" width="35" height="35" src={ infoIcon }/></button></Link>
            <h2 className="view-title"><FormattedMessage id="title_sitemap"/></h2>
            <p>Le site est divisé en deux catégories. Pour accéder uniquement au portfolio, suivez <Link to={"../portfolio"}>ce lien</Link>. Pour accéder au site web complet, accédez à <Link to={"../home"}>cette page</Link>.</p>
            <h4><FormattedMessage id="mainWebsite"/></h4>
            <ul className="sitemapList">
                <li><Link to={"../home"}><FormattedMessage id="title_aboutme"/></Link></li>
                <li><Link to={"../collections"}><FormattedMessage id="services"/></Link></li>
                <li>
                    <ul className="sitemapList">
                        <li><Link to={"../brandidentity"}><FormattedMessage id="brandIdentity"/></Link></li>
                        <li><Link to={"../photography"}><FormattedMessage id="photography"/></Link></li>
                        <li><Link to={"../typography"}><FormattedMessage id="typography"/></Link></li>
                        <li><Link to={"../animation"}>Animation</Link></li>
                        <li><Link to={"../packaging"}>Packaging</Link></li>
                    </ul>
                </li>
                        <li><a href={`./content/${cv_file}.pdf`} target="_blank" rel="noreferrer"><FormattedMessage id="cv"/></a></li>
                <li><Link to={"../collections"}>Contact</Link></li>
            </ul>
            <h4><FormattedMessage id="fullPortfolio"/></h4>
            <ul className="sitemapList">
                <li><Link to={"../portfolio"}><FormattedMessage id="homepage"/></Link></li>
                <li><Link to={"../collections"}>Collections</Link></li>
                <li>
                    <ul className="sitemapList">
                        <li><Link to={"../photography?display=portfolio"}><FormattedMessage id="photography"/></Link></li>
                        <li><Link to={"../collections/view?id=animations"}><FormattedMessage id="animation"/></Link></li>
                    </ul>
                </li>
                <li><Link to={"../gallery"}><FormattedMessage id="gallery"/></Link></li>
            </ul>
        </div>
    );
}